import { predicates } from "../predicates";
import type { ObjectTypeConfig } from "../types";

export const WORKSPACE_TEAM: ObjectTypeConfig = {
  actions: [
    // Open leads — same position as every other resource menu.
    {
      id: "open",
      surfaces: ["left-rail"],
      presentation: "menu-item",
    },
    // Creation — a workspace is a container, so creation follows Open (at the
    // top level; folder-scoped creation lives on the Canvases/Chats/Files
    // section kebabs). Handler-gated: surfaces that don't wire
    // newCanvas/newChat (cards, page header) simply don't show them.
    {
      id: "new-canvas",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotEdit,
    },
    // New chat is deliberately NOT a rail action: the rail tree shows
    // canvases and files, and a chat created here would materialize nowhere
    // in it. Chats are created where they are visible (Chats tab, composer).
    {
      id: "new-chat",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotEdit,
    },
    // The workspace root is a folder like any other in the tree, so it
    // carries the same create verbs its folders do. Handler-gated: surfaces
    // that don't wire them (cards, page header) simply don't show them.
    {
      id: "new-document",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotEdit,
    },
    {
      id: "new-folder",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotEdit,
    },
    {
      id: "upload-files",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotEdit,
    },
    {
      id: "upload-folder",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotEdit,
    },
    {
      id: "edit-workspace",
      surfaces: ["left-rail", "page-header", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotEdit,
    },
    {
      id: "add-members",
      surfaces: ["left-rail", "page-header", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotShare,
    },
    {
      id: "delete",
      surfaces: ["left-rail", "page-header", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: { any: [predicates.privateWorkspace, predicates.cannotEdit] },
    },
  ],
};

export const WORKSPACE_PRIVATE: ObjectTypeConfig = {
  actions: [
    // Open leads — same position as every other resource menu.
    {
      id: "open",
      surfaces: ["left-rail"],
      presentation: "menu-item",
    },
    // My Workspace can't be edited/shared/trashed, but it's still a container —
    // creation actions are the rest of its rail menu.
    {
      id: "new-canvas",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotEdit,
    },
    // New chat is deliberately NOT a rail action: the rail tree shows
    // canvases and files, and a chat created here would materialize nowhere
    // in it. Chats are created where they are visible (Chats tab, composer).
    {
      id: "new-chat",
      surfaces: ["context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotEdit,
    },
    // My Workspace is a file container too (no edit/members/delete).
    {
      id: "new-document",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotEdit,
    },
    {
      id: "new-folder",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotEdit,
    },
    {
      id: "upload-files",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotEdit,
    },
    {
      id: "upload-folder",
      surfaces: ["left-rail", "context-menu"],
      presentation: "menu-item",
      hiddenWhen: predicates.cannotEdit,
    },
  ],
};
